export function ChevronRight(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="9"
        height="18"
        viewBox="0 0 9 18"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.619069 1.08889C1.08871 0.686341 1.77994 0.710267 2.22069 1.12436L2.31113 1.21905L7.75331 7.56826C8.42025 8.34637 8.45731 9.47399 7.86446 10.2909L7.75331 10.4317L2.31113 16.781C1.87982 17.2841 1.12226 17.3424 0.619069 16.9111C0.149424 16.5086 0.0673514 15.8218 0.409164 15.3229L0.488911 15.2191L5.81902 9L0.488911 2.78095C0.086358 2.31131 0.110284 1.62008 0.524376 1.17933L0.619069 1.08889Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
